const REVOKE_DELAY_MS = 60_000

export function downloadBlob(blob: Blob, filename: string): void {
	const url = URL.createObjectURL(blob)
	const anchor = document.createElement('a')
	anchor.href = url
	anchor.download = filename
	document.body.appendChild(anchor)
	anchor.click()
	anchor.remove()
	// Revoking right after click() cancels the download in some Safari versions.
	setTimeout(() => URL.revokeObjectURL(url), REVOKE_DELAY_MS)
}
